// Source-of-truth for the code panel on /test. One record per Tier 1 step,
// in three languages. Keep these in sync with scenarios.ts — when a step
// changes there, change it here too.

export type Language = 'js' | 'python' | 'curl'

export interface Snippet {
  step: string
  js: string
  python: string
  curl: string
}

const HEADERS_JS = `headers: {
  'X-App-Id': process.env.KZ_APP_ID,
  'X-Api-Key': process.env.KZ_API_KEY,
  'X-Participant-Id': participantId,
  'Content-Type': 'application/json',
}`

const HEADERS_PY = `headers = {
    'X-App-Id': os.environ['KZ_APP_ID'],
    'X-Api-Key': os.environ['KZ_API_KEY'],
    'X-Participant-Id': participant_id,
    'Content-Type': 'application/json',
}`

const HEADERS_CURL = `-H "X-App-Id: $KZ_APP_ID" \\
  -H "X-Api-Key: $KZ_API_KEY" \\
  -H "X-Participant-Id: $KZ_PARTICIPANT" \\
  -H "Content-Type: application/json"`

export const snippets: Snippet[] = [
  {
    step: 'GET /status',
    js: `const response = await fetch('https://api.konexzero.com/api/v1/status', {
  ${HEADERS_JS},
})
const { data } = await response.json()
console.log(data.application) // your app name`,
    python: `import os, requests

${HEADERS_PY}

response = requests.get('https://api.konexzero.com/api/v1/status', headers=headers)
print(response.json()['data']['application'])`,
    curl: `curl https://api.konexzero.com/api/v1/status \\
  ${HEADERS_CURL}`,
  },
  {
    step: 'POST /credentials',
    js: `const response = await fetch('https://api.konexzero.com/api/v1/credentials', {
  method: 'POST',
  ${HEADERS_JS},
  body: JSON.stringify({ ttl: 3600 }),
})
const { data } = await response.json()
const peerConnection = new RTCPeerConnection({ iceServers: data.ice_servers })`,
    python: `response = requests.post(
    'https://api.konexzero.com/api/v1/credentials',
    headers=headers,
    json={'ttl': 3600},
)
ice_servers = response.json()['data']['ice_servers']`,
    curl: `curl -X POST https://api.konexzero.com/api/v1/credentials \\
  ${HEADERS_CURL} \\
  -d '{"ttl": 3600}'`,
  },
  {
    step: 'POST /rooms/{id}/join',
    js: `const response = await fetch(\`https://api.konexzero.com/api/v1/rooms/\${roomId}/join\`, {
  method: 'POST',
  ${HEADERS_JS},
  body: JSON.stringify({ display_name: 'Alice', room_type: 'group' }),
})
const { data } = await response.json()
const wsToken = data.ws_token`,
    python: `response = requests.post(
    f'https://api.konexzero.com/api/v1/rooms/{room_id}/join',
    headers=headers,
    json={'display_name': 'Alice', 'room_type': 'group'},
)
ws_token = response.json()['data']['ws_token']`,
    curl: `curl -X POST https://api.konexzero.com/api/v1/rooms/$KZ_ROOM/join \\
  ${HEADERS_CURL} \\
  -d '{"display_name":"Alice","room_type":"group"}'`,
  },
  {
    step: 'POST /rooms/{id}/messages',
    js: `await fetch(\`https://api.konexzero.com/api/v1/rooms/\${roomId}/messages\`, {
  method: 'POST',
  ${HEADERS_JS},
  body: JSON.stringify({
    message_type: 'text',
    content: 'Hello, everyone!',
  }),
})`,
    python: `requests.post(
    f'https://api.konexzero.com/api/v1/rooms/{room_id}/messages',
    headers=headers,
    json={'message_type': 'text', 'content': 'Hello, everyone!'},
)`,
    curl: `curl -X POST https://api.konexzero.com/api/v1/rooms/$KZ_ROOM/messages \\
  ${HEADERS_CURL} \\
  -d '{"message_type":"text","content":"Hello, everyone!"}'`,
  },
  {
    step: 'POST /rooms/{id}/leave',
    js: `await fetch(\`https://api.konexzero.com/api/v1/rooms/\${roomId}/leave\`, {
  method: 'POST',
  ${HEADERS_JS},
})`,
    python: `requests.post(
    f'https://api.konexzero.com/api/v1/rooms/{room_id}/leave',
    headers=headers,
)`,
    curl: `curl -X POST https://api.konexzero.com/api/v1/rooms/$KZ_ROOM/leave \\
  ${HEADERS_CURL}`,
  },
]
